class HeroSlider extends HTMLElement {
  constructor() {
    super();
    
    this.slider = this.querySelector('.hero-slider');
    this.initSlider();
  }

  initSlider() {
    const imageSlider = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },
       autoplay: {
        delay: 3000,
      },
    });
  }
}

customElements.define('hero-slider', HeroSlider);
